var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 567,
    height: 534,
    viewBox: "0 0 567 534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14581",
    "data-name": "Group 14581",
    transform: "translate(-268 -3857)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14252",
    "data-name": "Group 14252",
    transform: "translate(-447 3417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2497",
    "data-name": "Rectangle 2497",
    transform: "translate(810 627)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 398,
    height: 301,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 397,
    height: 300,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Conversions",
    transform: "translate(835 676)",
    fill: "#111",
    fontSize: 20,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Conversions")), /*#__PURE__*/React.createElement("text", {
    id: "Available:_21_600.76",
    "data-name": "Available: $21,600.76",
    transform: "translate(1022 774)",
    fill: "gray",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Available: $21,600.76")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7484",
    "data-name": "Group 7484",
    transform: "translate(-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2539",
    "data-name": "Rectangle 2539",
    transform: "translate(845 725)",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 135,
    rx: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 134,
    rx: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2540",
    "data-name": "Rectangle 2540",
    width: 16,
    height: 26,
    transform: "translate(837 781)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-insert-link",
    "data-name": "Icon material-insert-link",
    d: "M1.534,4.038a2.506,2.506,0,0,0,2.5,2.5h3.23V8.076H4.038A4.038,4.038,0,0,1,4.038,0h3.23V1.534H4.038A2.506,2.506,0,0,0,1.534,4.038ZM4.846,3.23h6.461V4.846H4.846Zm7.269,4.846H8.884V6.542h3.23a2.5,2.5,0,1,0,0-5.007H8.884V0h3.23a4.038,4.038,0,0,1,0,8.076Z",
    transform: "translate(849.602 784.509) rotate(90)",
    fill: "#849c91"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2541",
    "data-name": "Rectangle 2541",
    width: 8,
    height: 139,
    transform: "translate(854 721)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Available:_45_600.00",
    "data-name": "Available: \\u20B945,600.00",
    transform: "translate(1022 896)",
    fill: "gray",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Available: \u20B945,600.00")), /*#__PURE__*/React.createElement("g", {
    id: "Group_7442",
    "data-name": "Group 7442",
    transform: "translate(1022 705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2499",
    "data-name": "Rectangle 2499",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 48,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 165,
    height: 47,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "_185-united_states_of_america",
    "data-name": "185-united states of america",
    transform: "translate(14 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2500",
    "data-name": "Rectangle 2500",
    width: 25.69,
    height: 17.938,
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7436",
    "data-name": "Group 7436",
    transform: "translate(0 2.287)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2501",
    "data-name": "Rectangle 2501",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2502",
    "data-name": "Rectangle 2502",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 3.693)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2503",
    "data-name": "Rectangle 2503",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 7.385)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2504",
    "data-name": "Rectangle 2504",
    width: 25.69,
    height: 2.287,
    transform: "translate(0 11.077)",
    fill: "#f0f0f0"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2505",
    "data-name": "Rectangle 2505",
    width: 14.789,
    height: 10.618,
    transform: "translate(0 0)",
    fill: "#2e52b2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7437",
    "data-name": "Group 7437",
    transform: "translate(1.502 1.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221",
    "data-name": "Path 221",
    d: "M83.372,160.624l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-79.107 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_222",
    "data-name": "Path 222",
    d: "M83.609,207.13l-.238-.733-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-79.107 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_223",
    "data-name": "Path 223",
    d: "M27.247,207.13l-.238-.733-.238.733H26l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-26.001 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M27.01,160.624l-.238.733H26l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-26.001 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_225",
    "data-name": "Path 225",
    d: "M83.372,114.85l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-79.107 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_226",
    "data-name": "Path 226",
    d: "M27.01,114.85l-.238.733H26l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-26.001 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_227",
    "data-name": "Path 227",
    d: "M139.734,160.624l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-132.213 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_228",
    "data-name": "Path 228",
    d: "M139.971,207.13l-.238-.733-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-132.213 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_229",
    "data-name": "Path 229",
    d: "M196.334,207.13l-.238-.733-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453Z",
    transform: "translate(-185.32 -201.108)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M196.1,160.624l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-185.32 -157.98)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M139.734,114.85l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-132.213 -114.85)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M196.1,114.85l-.238.733h-.77l.623.453-.238.733.623-.453.623.453-.238-.733.623-.453h-.77Z",
    transform: "translate(-185.32 -114.85)",
    fill: "#f0f0f0"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "USD",
    transform: "translate(52.441 29)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "USD")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M11.8,15.729l4.244-4.247a.8.8,0,0,1,1.133,0,.809.809,0,0,1,0,1.136L12.369,17.43a.8.8,0,0,1-1.106.023L6.421,12.622a.8.8,0,1,1,1.133-1.136Z",
    transform: "translate(137.812 9.847)",
    fill: "#111",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7439",
    "data-name": "Group 7439",
    transform: "translate(856 705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2498",
    "data-name": "Rectangle 2498",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 48,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 155,
    height: 47,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2508",
    "data-name": "Rectangle 2508",
    width: 34,
    height: 34,
    rx: 6,
    transform: "translate(7 7)",
    fill: "#dfece5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_1_000.00",
    "data-name": "1,000.00",
    transform: "translate(57.635 30)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1,000.00")), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    transform: "translate(18 31)",
    fill: "#111",
    fontSize: 18,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7440",
    "data-name": "Group 7440",
    transform: "translate(856 827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2509",
    "data-name": "Rectangle 2509",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 48,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 155,
    height: 47,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2510",
    "data-name": "Rectangle 2510",
    width: 34,
    height: 34,
    rx: 6,
    transform: "translate(7 7)",
    fill: "#dfece5"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_80_455.00",
    "data-name": "80,455.00",
    transform: "translate(57.665 30)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "80,455.00")), /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": "\\u20B9",
    transform: "translate(18 31)",
    fill: "#111",
    fontSize: 18,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20B9"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7441",
    "data-name": "Group 7441",
    transform: "translate(1022 827)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2511",
    "data-name": "Rectangle 2511",
    fill: "#fff",
    stroke: "#dae2d6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 48,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 165,
    height: 47,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "INR",
    transform: "translate(53.333 29)",
    fill: "#111",
    fontSize: 16,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.02em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INR")), /*#__PURE__*/React.createElement("g", {
    id: "_055-india",
    "data-name": "055-india",
    transform: "translate(13.32 15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2512",
    "data-name": "Rectangle 2512",
    width: 25.37,
    height: 17.304,
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2513",
    "data-name": "Rectangle 2513",
    width: 25.37,
    height: 6.678,
    fill: "#ff9811"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2514",
    "data-name": "Rectangle 2514",
    width: 25.37,
    height: 6.678,
    transform: "translate(0 10.627)",
    fill: "#6da544"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.576,
    cy: 2.576,
    r: 2.576,
    transform: "translate(10.109 6.076)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 1.61,
    cy: 1.61,
    r: 1.61,
    transform: "translate(11.075 7.042)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_233",
    "data-name": "Path 233",
    d: "M228.4,222.146l.5,1.127,1.224-.133-.727.993.727.993-1.224-.133-.5,1.127-.5-1.127-1.224.133.727-.993-.727-.993,1.224.133Z",
    transform: "translate(-215.717 -215.481)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-2",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M11.8,15.729l4.244-4.247a.8.8,0,0,1,1.133,0,.809.809,0,0,1,0,1.136L12.369,17.43a.8.8,0,0,1-1.106.023L6.421,12.622a.8.8,0,1,1,1.133-1.136Z",
    transform: "translate(137.813 9.754)",
    fill: "#111",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("text", {
    id: "_1.00_USD_81.25_INR",
    "data-name": "1.00 USD = 81.25 INR",
    transform: "translate(856 784.5)",
    fill: "#1a211f",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1.00 USD = 81.25 INR")), /*#__PURE__*/React.createElement("text", {
    id: "Today_at_01:14_PM",
    "data-name": "Today at 01:14 PM",
    transform: "translate(856 805.5)",
    fill: "gray",
    fontSize: 13,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Today at 01:14 PM")), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down-3",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M12.415,13.322l4.708,4.557a.907.907,0,0,0,1.257,0,.848.848,0,0,0,0-1.219L13.045,11.5a.91.91,0,0,0-1.227-.025L6.447,16.657a.846.846,0,0,0,0,1.219.907.907,0,0,0,1.257,0Z",
    transform: "translate(995.638 795.632) rotate(180)",
    fill: "#1a211f",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4796",
    "data-name": "Path 4796",
    d: "M-12810.248-8803.293v4.631h-4.353",
    transform: "translate(13572 12899)",
    fill: "none",
    stroke: "#12a15a",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4796-2",
    "data-name": "Path 4796",
    d: "M-12810.248-8803.293v4.631h-4.353",
    transform: "translate(13572 12899)",
    fill: "none",
    stroke: "#12a15a",
    strokeLinecap: "round",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14189",
    "data-name": "Group 14189",
    transform: "translate(496.458 2861.42)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2566",
    "data-name": "Ellipse 2566",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2539",
    "data-name": "Ellipse 2539",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2567",
    "data-name": "Ellipse 2567",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-2",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2568",
    "data-name": "Ellipse 2568",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2540",
    "data-name": "Ellipse 2540",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2569",
    "data-name": "Ellipse 2569",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-3",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2570",
    "data-name": "Ellipse 2570",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2541",
    "data-name": "Ellipse 2541",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2571",
    "data-name": "Ellipse 2571",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-4",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2572",
    "data-name": "Ellipse 2572",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2534",
    "data-name": "Ellipse 2534",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2573",
    "data-name": "Ellipse 2573",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-5",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1254.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2561",
    "data-name": "Ellipse 2561",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1395.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2531",
    "data-name": "Ellipse 2531",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1325.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2574",
    "data-name": "Ellipse 2574",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1466.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-6",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2575",
    "data-name": "Ellipse 2575",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2542",
    "data-name": "Ellipse 2542",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2576",
    "data-name": "Ellipse 2576",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-7",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2577",
    "data-name": "Ellipse 2577",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2543",
    "data-name": "Ellipse 2543",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2578",
    "data-name": "Ellipse 2578",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-8",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2579",
    "data-name": "Ellipse 2579",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2544",
    "data-name": "Ellipse 2544",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2580",
    "data-name": "Ellipse 2580",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-9",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2581",
    "data-name": "Ellipse 2581",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2535",
    "data-name": "Ellipse 2535",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2582",
    "data-name": "Ellipse 2582",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-10",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1266.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2562",
    "data-name": "Ellipse 2562",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1407.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2532",
    "data-name": "Ellipse 2532",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1337.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2583",
    "data-name": "Ellipse 2583",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1478.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-11",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2584",
    "data-name": "Ellipse 2584",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2545",
    "data-name": "Ellipse 2545",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2585",
    "data-name": "Ellipse 2585",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-12",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2586",
    "data-name": "Ellipse 2586",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2546",
    "data-name": "Ellipse 2546",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2587",
    "data-name": "Ellipse 2587",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-13",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2588",
    "data-name": "Ellipse 2588",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2547",
    "data-name": "Ellipse 2547",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2589",
    "data-name": "Ellipse 2589",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-14",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2590",
    "data-name": "Ellipse 2590",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2536",
    "data-name": "Ellipse 2536",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2591",
    "data-name": "Ellipse 2591",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-15",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1278.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2563",
    "data-name": "Ellipse 2563",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1419.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2533",
    "data-name": "Ellipse 2533",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1349.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2592",
    "data-name": "Ellipse 2592",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1490.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-16",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2593",
    "data-name": "Ellipse 2593",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2548",
    "data-name": "Ellipse 2548",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2594",
    "data-name": "Ellipse 2594",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-17",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2595",
    "data-name": "Ellipse 2595",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2549",
    "data-name": "Ellipse 2549",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2596",
    "data-name": "Ellipse 2596",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-18",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2597",
    "data-name": "Ellipse 2597",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2550",
    "data-name": "Ellipse 2550",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2598",
    "data-name": "Ellipse 2598",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-19",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2599",
    "data-name": "Ellipse 2599",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2537",
    "data-name": "Ellipse 2537",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2600",
    "data-name": "Ellipse 2600",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-20",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1289.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2564",
    "data-name": "Ellipse 2564",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1430.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2538",
    "data-name": "Ellipse 2538",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1360.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2601",
    "data-name": "Ellipse 2601",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1501.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-21",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2602",
    "data-name": "Ellipse 2602",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2551",
    "data-name": "Ellipse 2551",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2603",
    "data-name": "Ellipse 2603",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-22",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2604",
    "data-name": "Ellipse 2604",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2552",
    "data-name": "Ellipse 2552",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2605",
    "data-name": "Ellipse 2605",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-23",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2606",
    "data-name": "Ellipse 2606",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2553",
    "data-name": "Ellipse 2553",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2607",
    "data-name": "Ellipse 2607",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-24",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2608",
    "data-name": "Ellipse 2608",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2554",
    "data-name": "Ellipse 2554",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2609",
    "data-name": "Ellipse 2609",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-25",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1301.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2565",
    "data-name": "Ellipse 2565",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1442.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2555",
    "data-name": "Ellipse 2555",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1372.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2610",
    "data-name": "Ellipse 2610",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1513.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-26",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2611",
    "data-name": "Ellipse 2611",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2556",
    "data-name": "Ellipse 2556",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2612",
    "data-name": "Ellipse 2612",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-27",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2613",
    "data-name": "Ellipse 2613",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2557",
    "data-name": "Ellipse 2557",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2614",
    "data-name": "Ellipse 2614",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-28",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2615",
    "data-name": "Ellipse 2615",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2558",
    "data-name": "Ellipse 2558",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2616",
    "data-name": "Ellipse 2616",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-29",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2617",
    "data-name": "Ellipse 2617",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2559",
    "data-name": "Ellipse 2559",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2618",
    "data-name": "Ellipse 2618",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1525.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-30",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1313.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2619",
    "data-name": "Ellipse 2619",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1454.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2560",
    "data-name": "Ellipse 2560",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1384.58)",
    fill: "#176b41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2620",
    "data-name": "Ellipse 2620",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1525.58)",
    fill: "#176b41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14153",
    "data-name": "Group 14153",
    transform: "translate(-17.542 2739.42)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-31",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1254.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2566-2",
    "data-name": "Ellipse 2566",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1395.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2539-2",
    "data-name": "Ellipse 2539",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1325.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-32",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1254.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2568-2",
    "data-name": "Ellipse 2568",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1395.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2540-2",
    "data-name": "Ellipse 2540",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1325.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-33",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1254.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2570-2",
    "data-name": "Ellipse 2570",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1395.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2541-2",
    "data-name": "Ellipse 2541",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1325.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-34",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1254.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3268",
    "data-name": "Ellipse 3268",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1254.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2572-2",
    "data-name": "Ellipse 2572",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1395.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3253",
    "data-name": "Ellipse 3253",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1395.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2534-2",
    "data-name": "Ellipse 2534",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1325.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3254",
    "data-name": "Ellipse 3254",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1325.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-35",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1254.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3269",
    "data-name": "Ellipse 3269",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1254.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2561-2",
    "data-name": "Ellipse 2561",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1395.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3250",
    "data-name": "Ellipse 3250",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1395.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2531-2",
    "data-name": "Ellipse 2531",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1325.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3255",
    "data-name": "Ellipse 3255",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1325.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-36",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1266.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2575-2",
    "data-name": "Ellipse 2575",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1407.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2542-2",
    "data-name": "Ellipse 2542",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1337.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-37",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1266.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2577-2",
    "data-name": "Ellipse 2577",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1407.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2543-2",
    "data-name": "Ellipse 2543",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1337.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-38",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1266.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2579-2",
    "data-name": "Ellipse 2579",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1407.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2544-2",
    "data-name": "Ellipse 2544",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1337.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-39",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1266.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3270",
    "data-name": "Ellipse 3270",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1266.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2581-2",
    "data-name": "Ellipse 2581",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1407.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3256",
    "data-name": "Ellipse 3256",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1407.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2535-2",
    "data-name": "Ellipse 2535",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1337.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3257",
    "data-name": "Ellipse 3257",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1337.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-40",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1266.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3271",
    "data-name": "Ellipse 3271",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1266.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2562-2",
    "data-name": "Ellipse 2562",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1407.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3251",
    "data-name": "Ellipse 3251",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1407.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2532-2",
    "data-name": "Ellipse 2532",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1337.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3258",
    "data-name": "Ellipse 3258",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1337.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-41",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1278.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2584-2",
    "data-name": "Ellipse 2584",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1419.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2545-2",
    "data-name": "Ellipse 2545",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1349.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-42",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1278.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2586-2",
    "data-name": "Ellipse 2586",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1419.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2546-2",
    "data-name": "Ellipse 2546",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1349.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-43",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1278.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2588-2",
    "data-name": "Ellipse 2588",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1419.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2547-2",
    "data-name": "Ellipse 2547",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1349.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-44",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1278.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3272",
    "data-name": "Ellipse 3272",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1278.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2590-2",
    "data-name": "Ellipse 2590",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1419.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3259",
    "data-name": "Ellipse 3259",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1419.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2536-2",
    "data-name": "Ellipse 2536",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1349.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3260",
    "data-name": "Ellipse 3260",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1349.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-45",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1278.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3273",
    "data-name": "Ellipse 3273",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1278.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2563-2",
    "data-name": "Ellipse 2563",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1419.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3252",
    "data-name": "Ellipse 3252",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1419.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2533-2",
    "data-name": "Ellipse 2533",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1349.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3261",
    "data-name": "Ellipse 3261",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1349.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-46",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1289.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2548-2",
    "data-name": "Ellipse 2548",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1360.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-47",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1289.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2549-2",
    "data-name": "Ellipse 2549",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1360.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-48",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1289.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2550-2",
    "data-name": "Ellipse 2550",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1360.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-49",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1289.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3274",
    "data-name": "Ellipse 3274",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1289.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2537-2",
    "data-name": "Ellipse 2537",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1360.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3262",
    "data-name": "Ellipse 3262",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1360.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-50",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1289.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3275",
    "data-name": "Ellipse 3275",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1289.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2538-2",
    "data-name": "Ellipse 2538",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1360.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3263",
    "data-name": "Ellipse 3263",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1360.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-51",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1301.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2551-2",
    "data-name": "Ellipse 2551",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1372.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-52",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1301.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2552-2",
    "data-name": "Ellipse 2552",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1372.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-53",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1301.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2553-2",
    "data-name": "Ellipse 2553",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1372.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-54",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1301.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3276",
    "data-name": "Ellipse 3276",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1301.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2554-2",
    "data-name": "Ellipse 2554",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1372.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3264",
    "data-name": "Ellipse 3264",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1372.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-55",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1301.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3277",
    "data-name": "Ellipse 3277",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1301.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2555-2",
    "data-name": "Ellipse 2555",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1372.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3265",
    "data-name": "Ellipse 3265",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1372.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-56",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1313.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2556-2",
    "data-name": "Ellipse 2556",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(285.542 1384.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-57",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1313.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2557-2",
    "data-name": "Ellipse 2557",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(297.542 1384.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-58",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1313.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2558-2",
    "data-name": "Ellipse 2558",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(309.542 1384.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-59",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1313.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3278",
    "data-name": "Ellipse 3278",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1313.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2559-2",
    "data-name": "Ellipse 2559",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(320.542 1384.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3266",
    "data-name": "Ellipse 3266",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(343.542 1384.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_96-60",
    "data-name": "Ellipse 96",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1313.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3279",
    "data-name": "Ellipse 3279",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1313.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2560-2",
    "data-name": "Ellipse 2560",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(332.542 1384.58)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3267",
    "data-name": "Ellipse 3267",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(355.542 1384.58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14150",
    "data-name": "Group 14150",
    transform: "translate(-878 1912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    transform: "translate(1450 2009)",
    fill: "#fff",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 175,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 262,
    height: 174,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "GBP",
    transform: "translate(1522.641 2060)",
    fill: "#111",
    fontSize: 26,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GBP")), /*#__PURE__*/React.createElement("g", {
    id: "_109-united_kingdom",
    "data-name": "109-united kingdom",
    transform: "translate(1470 2038)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 40,
    height: 26.667,
    transform: "translate(0 0)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M22.5,85.33h-5V96.163H0v5H17.5V112h5V101.163H40v-5H22.5Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_43",
    "data-name": "Group 43",
    transform: "translate(24.348 17.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M393.785,315.358l9.236,5.131v-5.131Z",
    transform: "translate(-387.368 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M311.652,315.358l15.652,8.7v-2.459l-11.226-6.237Z",
    transform: "translate(-311.652 -315.358)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M323.135,351.378,311.652,345v6.38Z",
    transform: "translate(-311.652 -342.682)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M311.652,315.358l15.652,8.7v-2.459l-11.226-6.237Z",
    transform: "translate(-287.304 -297.387)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M311.652,315.358l15.652,8.7v-2.459l-11.226-6.237Z",
    transform: "translate(-287.304 -297.387)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(0 17.971)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M7.058,315.356,0,319.277v-3.921Z",
    transform: "translate(0 -315.356)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M39.152,329.51v7.59H25.491Z",
    transform: "translate(-23.5 -328.404)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M11.226,315.358,0,321.595v2.459H0l15.652-8.7Z",
    transform: "translate(0 -297.387)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M9.236,136.089,0,130.958v5.131Z",
    transform: "translate(0 -127.393)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M15.652,94.026,0,85.33v2.459l11.226,6.237Z",
    transform: "translate(0 -85.33)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M53.366,85.33l11.483,6.38V85.33Z",
    transform: "translate(-49.197 -85.33)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M15.652,94.026,0,85.33v2.459l11.226,6.237Z",
    transform: "translate(0 -85.33)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M15.652,94.026,0,85.33v2.459l11.226,6.237Z",
    transform: "translate(0 -85.33)",
    fill: "#d80027"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(24.348 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M421.659,150.367l7.058-3.921v3.921Z",
    transform: "translate(-413.065 -141.671)",
    fill: "#0052b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    d: "M311.652,92.921v-7.59h13.661Z",
    transform: "translate(-311.652 -85.331)",
    fill: "#0052b4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M316.078,94.026,327.3,87.789V85.33h0l-15.652,8.7Z",
    transform: "translate(-287.304 -85.33)",
    fill: "#d80027"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_16_122.00",
    "data-name": "\\xA3 16,122.00",
    transform: "translate(1470 2146.333)",
    fill: "#111",
    fontSize: 32,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xA3"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    letterSpacing: "-0.1em"
  }), /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "16,122.00")), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 214,
    transform: "translate(1470 2092.666)",
    fill: "none",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7486",
    "data-name": "Group 7486",
    transform: "translate(1690 2028)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18",
    "data-name": "Ellipse 18",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19",
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 7)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 14)",
    fill: "#848b9c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14151",
    "data-name": "Group 14151",
    transform: "translate(-811 1653)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    transform: "translate(1097 2204)",
    fill: "#f5fffa",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 175,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 273,
    height: 174,
    rx: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "EUR",
    transform: "translate(1169.645 2259)",
    fill: "#111",
    fontSize: 26,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "0.01em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "EUR")), /*#__PURE__*/React.createElement("text", {
    id: "_3_005.00",
    "data-name": "\\u20AC 3,005.00",
    transform: "translate(1117 2341.333)",
    fill: "#111",
    fontSize: 32,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600,
    letterSpacing: "-0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u20AC 3,005.00")), /*#__PURE__*/React.createElement("line", {
    id: "Line_7",
    "data-name": "Line 7",
    x2: 225,
    transform: "translate(1117 2287.666)",
    fill: "none",
    stroke: "#bdd5c9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "eu",
    transform: "translate(1117 2236)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M0,0H40V27.534H0Z",
    fill: "#039"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7425",
    "data-name": "Group 7425",
    transform: "translate(10.85 4.817)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    transform: "translate(7.794 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b",
    transform: "translate(0.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M-6.721-23.7l-.39,1.3.65.13Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c",
    transform: "translate(0.964 0.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-2",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-3",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(1.748 2.579) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-4",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-5",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363",
    transform: "translate(7.794 15.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-2",
    "data-name": "b",
    transform: "translate(0.966 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-6",
    "data-name": "a",
    d: "M-6.721-23.7l-.39,1.3.65.13Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-2",
    "data-name": "c",
    transform: "translate(0.964 0.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-7",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-8",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362",
    transform: "translate(1.748 2.579) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-9",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-10",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e",
    transform: "translate(0 0.57)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369",
    transform: "translate(0 7.225)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-3",
    "data-name": "b",
    transform: "translate(0.966 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-11",
    "data-name": "a",
    d: "M-6.721-23.7l-.39,1.3.65.13Z",
    transform: "translate(7.111 23.704)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-3",
    "data-name": "c",
    transform: "translate(0.964 0.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-12",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-13",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368",
    transform: "translate(1.748 2.579) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-14",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-15",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7375",
    "data-name": "Group 7375",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 5.682, 3.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-4",
    "data-name": "b",
    transform: "translate(0.966 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-16",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-4",
    "data-name": "c",
    transform: "translate(0.964 0.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-17",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7371",
    "data-name": "Group 7371",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-18",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7374",
    "data-name": "Group 7374",
    transform: "translate(1.748 2.579) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7372",
    "data-name": "Group 7372",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-19",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-20",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_175",
    "data-name": "Path 175",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7381",
    "data-name": "Group 7381",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 4.319, 4.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-5",
    "data-name": "b",
    transform: "translate(0.966 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-21",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_176",
    "data-name": "Path 176",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-5",
    "data-name": "c",
    transform: "translate(0.964 0.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7376",
    "data-name": "Group 7376",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-22",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7377",
    "data-name": "Group 7377",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-23",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7380",
    "data-name": "Group 7380",
    transform: "translate(1.748 2.579) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7378",
    "data-name": "Group 7378",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-24",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7379",
    "data-name": "Group 7379",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-25",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180",
    "data-name": "Path 180",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7387",
    "data-name": "Group 7387",
    transform: "translate(3.277 10.844) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-6",
    "data-name": "b",
    transform: "translate(0.966 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-26",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181",
    "data-name": "Path 181",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-6",
    "data-name": "c",
    transform: "translate(0.964 0.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-27",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_182",
    "data-name": "Path 182",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7383",
    "data-name": "Group 7383",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-28",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_183",
    "data-name": "Path 183",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7386",
    "data-name": "Group 7386",
    transform: "translate(1.748 2.579) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7384",
    "data-name": "Group 7384",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-29",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_184",
    "data-name": "Path 184",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7385",
    "data-name": "Group 7385",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-30",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_185",
    "data-name": "Path 185",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7393",
    "data-name": "Group 7393",
    transform: "translate(6.096 13.459) rotate(72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-7",
    "data-name": "b",
    transform: "translate(0.966)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-31",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-7",
    "data-name": "c",
    transform: "translate(0.964 0.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7388",
    "data-name": "Group 7388",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-32",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7389",
    "data-name": "Group 7389",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-33",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_188",
    "data-name": "Path 188",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7392",
    "data-name": "Group 7392",
    transform: "translate(1.748 2.579) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7390",
    "data-name": "Group 7390",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-34",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_189",
    "data-name": "Path 189",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7391",
    "data-name": "Group 7391",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-35",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_190",
    "data-name": "Path 190",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7424",
    "data-name": "Group 7424",
    transform: "translate(18.3 17.404) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7399",
    "data-name": "Group 7399",
    transform: "translate(0 7.031)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-8",
    "data-name": "b",
    transform: "translate(0.966 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-36",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_191",
    "data-name": "Path 191",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-8",
    "data-name": "c",
    transform: "translate(0.964 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7394",
    "data-name": "Group 7394",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-37",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_192",
    "data-name": "Path 192",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7395",
    "data-name": "Group 7395",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-38",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_193",
    "data-name": "Path 193",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7398",
    "data-name": "Group 7398",
    transform: "translate(1.748 2.052) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7396",
    "data-name": "Group 7396",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-39",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_194",
    "data-name": "Path 194",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7397",
    "data-name": "Group 7397",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-40",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_195",
    "data-name": "Path 195",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7405",
    "data-name": "Group 7405",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 7.198, 15.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-9",
    "data-name": "b",
    transform: "translate(0.966 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-41",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-9",
    "data-name": "c",
    transform: "translate(0.964 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7400",
    "data-name": "Group 7400",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-42",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_197",
    "data-name": "Path 197",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7401",
    "data-name": "Group 7401",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-43",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_198",
    "data-name": "Path 198",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7404",
    "data-name": "Group 7404",
    transform: "translate(1.748 2.052) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7402",
    "data-name": "Group 7402",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-44",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_199",
    "data-name": "Path 199",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7403",
    "data-name": "Group 7403",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-45",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_200",
    "data-name": "Path 200",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7411",
    "data-name": "Group 7411",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 2.804, 13.945)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-10",
    "data-name": "b",
    transform: "translate(0.966 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-46",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-10",
    "data-name": "c",
    transform: "translate(0.964 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7406",
    "data-name": "Group 7406",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-47",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7407",
    "data-name": "Group 7407",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-48",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7410",
    "data-name": "Group 7410",
    transform: "translate(1.748 2.052) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7408",
    "data-name": "Group 7408",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-49",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7409",
    "data-name": "Group 7409",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-50",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7417",
    "data-name": "Group 7417",
    transform: "translate(0.824 5.194) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-11",
    "data-name": "b",
    transform: "translate(0.966 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-51",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-11",
    "data-name": "c",
    transform: "translate(0.964 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7412",
    "data-name": "Group 7412",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-52",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7413",
    "data-name": "Group 7413",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-53",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7416",
    "data-name": "Group 7416",
    transform: "translate(1.748 2.052) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7414",
    "data-name": "Group 7414",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-54",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7415",
    "data-name": "Group 7415",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-55",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7423",
    "data-name": "Group 7423",
    transform: "translate(3.643 2.579) rotate(-72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b-12",
    "data-name": "b",
    transform: "translate(0.966 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-56",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "c-12",
    "data-name": "c",
    transform: "translate(0.964 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7418",
    "data-name": "Group 7418",
    transform: "translate(0.148 1.611) rotate(-72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-57",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7419",
    "data-name": "Group 7419",
    transform: "matrix(-0.809, -0.588, 0.588, -0.809, 0.631, 1.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-58",
    "data-name": "a",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_213",
    "data-name": "Path 213",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7422",
    "data-name": "Group 7422",
    transform: "translate(1.748 2.052) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7420",
    "data-name": "Group 7420",
    transform: "translate(1.507 0) rotate(72)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-59",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7421",
    "data-name": "Group 7421",
    transform: "matrix(-0.809, 0.588, -0.588, -0.809, 1.47, 1.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a-60",
    "data-name": "a",
    d: "M.39,0,0,1.3l.65.13Z",
    transform: "translate(0 0)",
    fill: "#fc0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M.39,1.429,0,.13.65,0Z",
    transform: "translate(0.779 1.429) rotate(180)",
    fill: "#fc0"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7485",
    "data-name": "Group 7485",
    transform: "translate(1348 2232)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-2",
    "data-name": "Ellipse 18",
    cx: 2,
    cy: 2,
    r: 2,
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_19-2",
    "data-name": "Ellipse 19",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 7)",
    fill: "#848b9c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20-2",
    "data-name": "Ellipse 20",
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0 14)",
    fill: "#848b9c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank2);
export default __webpack_public_path__ + "static/media/bank-2.146478ce2a08215718403973d3710461.svg";
export { ForwardRef as ReactComponent };